module.exports = __webpack_public_path__ + "img/couples_16_V.ba20984f.webp";